// This icon file is generated automatically.
var PNotificationOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75.75a.47.47 0 00-.18.04l-9 3.61H1a.25.25 0 00-.25.26v4.68c0 .14.11.26.25.26h1.59a1.87 1.87 0 103.6 1.05l6.38 2.57a.5.5 0 00.18.03c.27 0 .5-.22.5-.52V1.27c0-.3-.23-.52-.5-.52zM4.37 10.91A.75.75 0 013.8 9.7l1.32.53a.75.75 0 01-.75.7zm7.75.91L3.98 8.55l-.2-.08h-1.9V5.53h1.9l.2-.08 8.15-3.27v9.64z", "fill-rule": "nonzero" } }] }, "name": "p-notification", "theme": "outlined" };
export default PNotificationOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PNotificationOutlined.js
// module id = 3525
// module chunks = 0